import Icon from "@react-native-vector-icons/material-design-icons/static";
import type { ReactNode } from "react";
import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import Box from "../../../components/Box";
import Button from "../../../components/Button";
import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";

type Props = {
	title: string;
	subtitle?: string;
} & (
	| { renderCta: () => ReactNode }
	| { ctaLabel: ReactNode; onPress: () => void }
);

export const NavRailBanner = ({ title, subtitle, ...props }: Props) => {
	const theme = useAppTheme();
	const { isShortScreen } = useDevice();

	const contents = (
		<Box
			backgroundColor={theme.colors.background}
			padding={16}
			borderRadius={theme.roundness * 4}
			gap={10}
		>
			<Box gap={8}>
				<Box
					flexDirection="row"
					alignItems="center"
					justifyContent="space-between"
					gap={8}
				>
					<Text variant="titleSmall">{title}</Text>
					{isShortScreen && (
						<Icon
							name="chevron-right"
							size={24}
							color={theme.colors.onSurface}
						/>
					)}
				</Box>
				{!isShortScreen && <Text variant="bodySmall">{subtitle}</Text>}
			</Box>
			{"renderCta" in props
				? props.renderCta()
				: !isShortScreen && (
						<Button
							mode="contained-tonal"
							onPress={props.onPress}
							buttonColor={theme.colors.tertiaryContainer}
							textColor={theme.colors.onTertiaryContainer}
							style={{ alignSelf: "flex-start" }}
						>
							{props.ctaLabel}
						</Button>
					)}
		</Box>
	);

	if (isShortScreen && "onPress" in props) {
		return (
			<Pressable
				onPress={props.onPress}
				accessibilityRole="button"
				accessibilityLabel={
					typeof props.ctaLabel === "string" ? props.ctaLabel : title
				}
			>
				{contents}
			</Pressable>
		);
	}

	return contents;
};
